import { LocalizationProvider, StaticDatePicker, PickersDayProps } from '@mui/x-date-pickers-pro'
import { AdapterDateFns } from '@mui/x-date-pickers-pro/AdapterDateFns'
import { useCallback } from 'react'

import type { TMultipleDatePickerProps } from './multiple_date_picker.d'
import { CustomPickersDay } from './custom_picker_day'

export const MultipleDatePicker = ({
  selectedDates,
  minDate,
  maxDate,
  onChange,
  shouldDisableDate,
}: TMultipleDatePickerProps) => {
  const renderPickerDay = useCallback(
    (date: Date, _selectedDates: Date[], pickersDayProps: PickersDayProps<Date>) => {
      const idx = selectedDates.findIndex((dc) => dc.getTime() === date.getTime()) ?? -1
      return <CustomPickersDay {...pickersDayProps} selected={idx >= 0} />
    },
    [selectedDates]
  )

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <StaticDatePicker
        displayStaticWrapperAs="desktop"
        showToolbar={false}
        value={selectedDates}
        minDate={minDate}
        maxDate={maxDate}
        shouldDisableDate={shouldDisableDate}
        onChange={onChange}
        renderDay={renderPickerDay}
        renderInput={(_props) => <></>}
        views={['day']}
      />
    </LocalizationProvider>
  )
}
